import { useVoucher } from "app/hooks/shared/useVoucher";
import { useState } from "react";
import { toast } from "react-toastify";
import FormGroup from "shared/ui/FormGroup";
import Button, { ButtonTypes } from "shared/ui/button";
import Input from "shared/ui/input";
import Label from "shared/ui/label";
import Modal from "shared/ui/modal";
import Heading from "shared/ui/typography/Heading";

interface Props {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  productContext?: string;
}

const AddVoucherModal = ({ isOpen, setIsOpen, productContext }: Props) => {
  const { addVoucher, isLoadingVoucher } = useVoucher();

  const [voucher, setVoucher] = useState("");
  const [validationErrorMessage, setValidationErrorMessage] = useState("");

  const submitVoucher = async () => {
    try {
      await addVoucher(voucher, productContext);
      setValidationErrorMessage("");
      setVoucher("");
      setIsOpen(false);
    } catch (e: any) {
      setValidationErrorMessage("Voucher is ongeldig");
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      className="gg-max-w-sm gg-px-6 gg-py-8"
      showCloseModalButton
    >
      <>
        <Heading headingLevel="h2" className="gg-mb-2 gg-text-2xl">
          Heb je een cadeaukaart of voucher?
        </Heading>

        <FormGroup
          displayError={!!validationErrorMessage}
          errorMessage={validationErrorMessage}
          className="gg-mb-7"
        >
          <Label htmlFor="voucher-code" className={"gg-mb-2"}>
            Vul hier je code in. De totaalprijs wordt direct aangepast.
          </Label>
          <Input
            onChange={(e) => setVoucher(e.target.value)}
            value={voucher}
            id="voucher-code"
            data-testid="add-voucher-input"
            placeholder=""
            className="gg-w-full"
            error={!!validationErrorMessage}
            required
          />
        </FormGroup>

        <Button
          type={ButtonTypes.DARK_BLUE}
          className={"gg-flex gg-w-full gg-justify-center gg-py-2"}
          onClick={() => submitVoucher()}
          loading={isLoadingVoucher}
          data-testid="submit-voucher-button"
        >
          Voeg toe
        </Button>
      </>
    </Modal>
  );
};
export default AddVoucherModal;
